export function login() {
    //mobile-login-active only applies on small screens (≤640px)
    const MOBILE_BREAKPOINT = 640;

    //Login panel toggle
    const loginBtn = $('.login-btn');
    const loginPanel = $('.olb-login');
    loginBtn.on('click', function(e) {
        e.preventDefault();
        loginPanel.toggleClass('show-login');
        //Only flag mobile-login-active when the panel is open and we're at/below the mobile breakpoint
        $('header').toggleClass('mobile-login-active', loginPanel.hasClass('show-login') && window.innerWidth <= MOBILE_BREAKPOINT);
        //Opening the login panel closes the mobile menu (mutually exclusive).
        //Use triggerHandler, not trigger: a real click would bubble to the
        //document outside-click handler and immediately re-close the login panel.
        if (loginPanel.hasClass('show-login') && $('.mobile-menu-container').hasClass('is-active')) {
            $('.hamburger').triggerHandler('click');
        }
    });

    //Clicking outsie of login panel closes it
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.olb-login, .login-btn').length) {
            loginPanel.removeClass('show-login');
            $('header').removeClass('mobile-login-active');
        }
    });

    //clicking the login-close-btn closes the login panel
    const loginCloseBtn = $('.login-close-btn');
    loginCloseBtn.on('click', function() {
        loginPanel.removeClass('show-login');
        $('header').removeClass('mobile-login-active');
    });

    //clicking on megamenu items should close the login panel. The megamenu
    //plugin stops click propagation, so a handler on .megamenu never receives
    //the bubbled click — bind directly on the links instead.
    $('.megamenu a').on('click', function() {
        loginPanel.removeClass('show-login');
        $('header').removeClass('mobile-login-active');
    });

    //Resizing above the mobile breakpoint clears the mobile-login-active flag
    $(window).on('resize', function() {
        if (window.innerWidth > MOBILE_BREAKPOINT) {
            $('header').removeClass('mobile-login-active');
        }
    });

    //Selection of account type in login form
    const loginAccountSelection = $('#accountSelect');
    loginAccountSelection.on('change', function() {
        const selectedValue = $(this).val();
        console.log('Selected account type:', selectedValue);
        if(selectedValue === 'business-plus') {
            $('#passwordField').hide();
        } else {
            $('#passwordField').show();
        }
    });
}